module.exports = __webpack_public_path__ + "resources/img/img_confluent_platform1_m.d0924a9bffeaf709b237b48c02e23fa6.png";